import { Injectable } from "@angular/core";

/*
  Generated class for the LocalstorageProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class LocalstorageProvider {
  constructor() {}

  info() {
    var _lsTotal = 0,
      _xLen,
      _x;
    for (_x in localStorage) {
      _xLen = (localStorage[_x].length + _x.length) * 2;
      _lsTotal += _xLen;
      console.log(_x.substr(0, 50) + " = " + (_xLen / 1024).toFixed(2) + " KB");
    }
    //console.log("Total = " + (_lsTotal / 1024).toFixed(2) + " KB");
  }

  getKeys() {
    let result = [];
    if (this.getStoredQuantity() > 0) {
      for (var i = 0; i < localStorage.length; i++) {
        result.push(localStorage.key(i));
      }
    }
    return result;
  }

  getPosKeys() {
    let filter = /^spot\-/i;
    let result = [];
    if (this.getStoredQuantity() > 0) {
      for (var i = 0; i < localStorage.length; i++) {
        if (filter.exec(localStorage.key(i))) {
          result.push(localStorage.key(i));
        }
      }
    }
    return result;
  }

  getCountPosKey() {
    return this.getPosKeys().length;
  }

  getStoredQuantity() {
    return localStorage.length;
  }

  remove(key) {
    localStorage.removeItem(key);
  }

  read(key) {
    return JSON.parse(localStorage.getItem(key));
  }

  write(key, value) {
    localStorage.setItem(key, JSON.stringify(value));
  }

  clear() {
    localStorage.clear();
  }
}
